<div class="map-wrap">
  <div *ngIf="overlayText && overlayTextActive" class="map-info d-flex">
    <mat-icon>info_outline</mat-icon>
    <p class="mb-0">{{ overlayText | translate }}</p>
    <mat-icon (click)="closeMapInfo()">close</mat-icon>
  </div>

  <button
    *ngIf="isRecenterButton && (firstWheel || firstDrag)"
    class="recentre-button"
    (click)="setMapAsInBeginning()"
    [translate]="'MapBoxComponent:RecentreButton'"
  >
    <mat-icon>gps_fixed</mat-icon>Re-centre map
  </button>

  <mgl-map
    [style]="'mapbox://styles/tengroup/cjky1w47n4puz2slkibp7cpmm'"
    [zoom]="disableZoom ? '' : zoom"
    [center]="center"
    [fitBounds]="bounds"
    [fitBoundsOptions]="boundsOptions"
    [cursorStyle]="cursorStyle"
    (load)="onMapLoad($event)"
    (moveEnd)="savePosition($event)"
    (wheel)="onWheel()"
    (zoomEnd)="onZoomEnd($event)"
    (dragStart)="onDragStart()"
  >
    <mgl-control mglNavigation position="bottom-right"></mgl-control>
    <mgl-control mglScale unit="imperial" position="top-right"></mgl-control>
  </mgl-map>
</div>
